import axios from '@/services/apiAxios';
import queryString from '@/utils/queryString';

export default {
    namespaced: true,
    state: {
        groups: [],
    },
    mutations: {
        setGroups(state, payload) {
            state.groups = payload;
        },
    }, 
    actions: {
        fetchGroups({ commit, rootState, dispatch }, payload) {
            let query = queryString(payload);
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `${rootState.accounting.routePrefix}/account-groups?${query}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    commit('setGroups', response.data);
                    resolve(response)
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                }
                );
            })
        },
        setGroups({commit}, payload) {
            commit("setGroups", payload);
        }

    }
}